import React from 'react';
import PropTypes from 'prop-types';
import { getOddsFromSelection } from '~shared/components/sport-event/utils';
import {
    useOddsFormat,
} from '~SpectateStore/hooks/userHooks';

const SwitchableOdds = ({ selection, eventActive, limitOddsDisplay = false }) => {
    const oddsFormat = useOddsFormat();
    const odds = getOddsFromSelection(selection, oddsFormat, eventActive, limitOddsDisplay);

    return <>{odds}</>;
};

SwitchableOdds.propTypes = {
    selection: PropTypes.object.isRequired,
    eventActive: PropTypes.bool,
    limitOddsDisplay: PropTypes.bool,
};

SwitchableOdds.defaultProps = {
    eventActive: true,
};

export default SwitchableOdds;
